import { OrganisationSportType } from 'lib/organisation-sport'

export function withSportTerminology(dictionary: Localication, sportType?: OrganisationSportType): Localication {
    if (sportType !== 'cue_sports') return dictionary
    return {
        ...dictionary,
        ...dictionary.cueAssociations,
        federationSettings: { ...dictionary.federationSettings, ...dictionary.cueAssociations.federationSettings },
        projectPlatform: { ...dictionary.projectPlatform, federations: dictionary.cueAssociations.federations }
    }
}
